export default "__VITE_ASSET__1bc32b98__"